import * as yup from "yup";

const itemSchema = (translate: Function) => yup.object().shape({
	ada002Codigo: yup.string().required(translate("Código é requerido")).when("$isRepeted",(isRepeted, schema) => (isRepeted ? schema.max(0,"Código está repetido") : schema)),
	ada002Descricao: yup.string().required(translate("Descrição é requerido")),
	ada002Ativo: yup.boolean()
});

export default  itemSchema;
